import { render, staticRenderFns } from "./InventoryTab.vue?vue&type=template&id=43116076"
import script from "./InventoryTab.vue?vue&type=script&lang=js"
export * from "./InventoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports